import React, { Fragment, useEffect } from "react";
import { connect } from "react-redux";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Nav } from "reactstrap";
import { approveStep, getApprovalStep, unapproveStep } from "./actions";
import _ from "lodash";
import { getCurrentUser } from "modules/current_user/actions";

import { f7, Button as MobileButton, Popup, Page, NavRight, Block, Link, Navbar } from "framework7-react";

function mapStateToProps(state) {
  return {
    approval_steps: state.approval_steps,
    current_user: state.current_user,
  };
}

const ApprovalStepButton = (props) => {
  const { approval_step_id, approval_steps, current_user, approval, mobile } = props;
  const approval_step = approval_steps[approval_step_id];
  const [modalOpen, setModalOpen] = React.useState(false);
  const toggle = () => setModalOpen(!modalOpen);

  const LabelElement = mobile ? Block : "span";

  useEffect(() => {
    if (!approval_step) {
      props.getApprovalStep(approval_step_id);
    }
  }, []);

  if (_.includes(approval_step?.user_ids, current_user.id) === false) {
    return (
      <LabelElement>
        <b>Only {approval_step?.users} can approve this.</b>
      </LabelElement>
    );
  }

  let approvable = true;
  if (approval?.steps) {
    const previous_steps = approval.steps.filter((s) => s.step_number < approval_step.step_number);
    if (previous_steps.length > 0) {
      approvable = _.every(previous_steps, (s) => s.approved === true);
    }
  }
  if (!approvable) {
    return (
      <LabelElement>
        <b>Requires previous step/s to be approved first.</b>
      </LabelElement>
    );
  }

  let unapprovable = approval_step?.approved;
  if (approval?.steps) {
    const subsequent_steps = approval.steps.filter((s) => s.step_number > approval_step.step_number);
    if (subsequent_steps.length > 0) {
      unapprovable = _.every(subsequent_steps, (s) => s.approved === false);
    }
  }
  if (approval_step?.approved && !unapprovable) {
    return (
      <LabelElement>
        <b>Requires subsequent step/s to be unapproved first.</b>
      </LabelElement>
    );
  }

  return mobile ? (
    <MobileView
      modalOpen={modalOpen}
      setModalOpen={setModalOpen}
      toggle={toggle}
      approval_step_id={approval_step_id}
      approval_step={approval_step}
      {...props}
    />
  ) : (
    <WebView
      modalOpen={modalOpen}
      setModalOpen={setModalOpen}
      toggle={toggle}
      approval_step_id={approval_step_id}
      approval_step={approval_step}
      {...props}
    />
  );
};

export default connect(mapStateToProps, { getApprovalStep, approveStep, unapproveStep, getCurrentUser })(ApprovalStepButton);

const WebView = (props) => {
  const { modalOpen, toggle, approval_step, setModalOpen, approval_step_id } = props;
  return (
    <Fragment>
      <Button size="sm" color={approval_step?.approved ? "danger" : "success"} onClick={() => setModalOpen(!modalOpen)}>
        {approval_step?.approved ? "Unapprove" : "Approve"}
      </Button>

      <Modal isOpen={modalOpen} toggle={toggle}>
        <ModalHeader toggle={toggle}>Approve Request</ModalHeader>
        <ModalBody>Are you sure you want to {approval_step?.approved ? <b>unapprove</b> : <b>approve</b>} this request?</ModalBody>
        <ModalFooter>
          <Button
            color={approval_step?.approved ? "danger" : "success"}
            onClick={() => {
              let request;
              if (approval_step?.approved) {
                request = props.unapproveStep(approval_step_id);
              } else {
                request = props.approveStep(approval_step_id);
              }
              request
                .then(() => {
                  setModalOpen(false);
                  props.getCurrentUser();
                })
                .catch((err) => {
                  setModalOpen(false);
                });
            }}
          >
            Yes
          </Button>
          <Button
            color="secondary"
            onClick={() => {
              setModalOpen(false);
            }}
          >
            No
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

const MobileView = (props) => {
  const { approval_step, modalOpen, setModalOpen, approval_step_id } = props;

  return (
    <Fragment>
      <MobileButton fill color={approval_step?.approved ? "red" : "green"} onClick={() => setModalOpen(!modalOpen)}>
        {approval_step?.approved ? "Unapprove" : "Approve"}
      </MobileButton>

      <Popup opened={modalOpen} id={`approval-step-button-${approval_step_id}`} onPopupClosed={() => setModalOpen(false)}>
        <Page>
          <Navbar title="Approve Request">
            <NavRight>
              <Link popupClose>Close</Link>
            </NavRight>
          </Navbar>
          <Block>Are you sure you want to {approval_step?.approved ? <b>unapprove</b> : <b>approve</b>} this request?</Block>
          <Block>
            <MobileButton
              fill
              color={approval_step?.approved ? "red" : "green"}
              className="margin"
              onClick={() => {
                let request;
                if (approval_step?.approved) {
                  request = props.unapproveStep(approval_step_id);
                } else {
                  request = props.approveStep(approval_step_id);
                }
                request.then(() => {
                  props.getCurrentUser();
                  f7.popup.close(`#approval-step-button-${approval_step_id}`);
                  f7.toast.create({
                    text: `${approval_step?.approved ? "Unapproved" : "Approved"}`,
                    position: "center",
                    closeTimeout: 2000,
                  }).open();
                });
                request.catch((err) => {
                  console.log(err);
                  f7.popup.close(`#approval-step-button-${approval_step_id}`);
                  f7.toast.create({
                    text: "Error",
                    position: "center",
                    closeTimeout: 2000,
                  }).open();
                });
              }}
            >
              Yes
            </MobileButton>
            <MobileButton
              color={approval_step?.approved ? "green" : "red"}
              className="margin"
              fill
              onClick={() => {
                f7.popup.close(`#approval-step-button-${approval_step_id}`);
              }}
            >
              No
            </MobileButton>
          </Block>
        </Page>
      </Popup>
    </Fragment>
  );
};
